import { render } from "./AppPhotoView.vue?vue&type=template&id=31fc54e0&scoped=true&ts=true"
import script from "./AppPhotoView.vue?vue&type=script&lang=ts"
export * from "./AppPhotoView.vue?vue&type=script&lang=ts"

import "./AppPhotoView.vue?vue&type=style&index=0&id=31fc54e0&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31fc54e0"]])

export default __exports__